import { InputAdornment } from '@mui/material';
import { EmojiPickerButton, EmojiPickerButtonProps } from './EmojiPickerButton';

export type EmojiAdornmentProps = EmojiPickerButtonProps & {
  /**
   * Vertical alignment inside the input.
   * Use `start` for multiline fields (icon sits on the first line);
   * `center` for single-line fields. Defaults to `start`.
   */
  align?: 'start' | 'center';
};

/**
 * Text-field end adornment that opens an emoji picker.
 * Pass directly as TextFieldElement `InputProps.endAdornment`.
 */
export function EmojiAdornment({ align = 'start', ...props }: EmojiAdornmentProps) {
  return (
    <InputAdornment
      position="end"
      sx={{
        alignSelf: align === 'start' ? 'flex-start' : 'center',
        ...(align === 'start' ? { mt: -0.5 } : null),
        mr: -1,
        ml: 0.5,
      }}
    >
      <EmojiPickerButton {...props} />
    </InputAdornment>
  );
}
